import { render, staticRenderFns } from "./EditRedsysPaymentConfig.vue?vue&type=template&id=b5100b98&"
import script from "./EditRedsysPaymentConfig.vue?vue&type=script&lang=ts&"
export * from "./EditRedsysPaymentConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports